import { render } from "./PersonalGoalList.vue?vue&type=template&id=6985a815&ts=true"
import script from "./PersonalGoalList.vue?vue&type=script&lang=ts"
export * from "./PersonalGoalList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__